// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[name=\"ActivityPopover\"] > div {\n    cursor: pointer;\n    color: #7A7A7A;\n    font-size: 14px;\n    padding: 6px 10px;\n  }\n    [name=\"ActivityPopover\"] > div .badge {\n      display: inline-block;\n      margin-left: 10px;\n      color: #EB6A5C;\n    }", ""]);
// Exports
module.exports = exports;
